import { Armchair, LampDesk, CookingPot, Bath, Layers, Wallpaper, Flower2, Wrench } from "lucide-react";

export const productCategoryIcons = {
  furniture: Armchair, lighting: LampDesk, kitchen: CookingPot, bathroom: Bath,
  flooring: Layers, wall: Wallpaper, decor: Flower2, service: Wrench
};
